/* prettier-ignore */

import { ConnectionTier, ImageVariantWidth } from '../interfaces';

/**
 * HRS-3471: maximum srcset candidate width per connection tier (`null` = no cap).
 * `low` keeps cards sharp at DPR 1 (242-300 CSS px slots); `medium` covers cards
 * at DPR ~2 and phone heroes at DPR 1 while avoiding `w800` and the original.
 */
export const CONNECTION_TIER_MAX_WIDTH: Readonly<Record<ConnectionTier, ImageVariantWidth | null>> = {
  low: 350,
  medium: 500,
  full: null,
};

/** `navigator.connection.effectiveType` values mapped to the `low` tier. */
export const LOW_EFFECTIVE_TYPES: readonly string[] = ['slow-2g', '2g'];

/** `navigator.connection.effectiveType` values mapped to the `medium` tier. */
export const MEDIUM_EFFECTIVE_TYPES: readonly string[] = ['3g'];
